import GradesVM from './grades-vm';
import AnalyticsVM from './analytics-vm';
import GradebookServices from '../services';
export default function() {
  var self = this;
  self.tabVMs = {
    GradesVM,
    AnalyticsVM
  };
  self.coursework_id = ko.observable();
  self.activeTab = ko.observable();
  self.coursework = ko.observable();

  self.grades = null;
  self.analytics = null;

  self.initUI = function() {

  };

  self.refreshURL = function () {
    if (self.coursework()) {
      var url = Kadenze.Routes.course_gradebook_coursework_path(self.course_id, self.coursework().slug(), {sheet: self.activeTab()});
      history.replaceState($.pjax.state, null, url);
    }
  };

  self.initCourseworkListing = function () {
    var coursework_listing = JSON.parse($('#coursework_listing_json').val());

    self.coursework_listing = ko.mapping.fromJS(coursework_listing);
    self.coursework_listing_families = ko.computed(function() {
      var list = ko.utils.arrayMap(self.coursework_listing(), function(cw){
        return cw['adaptive?']() ? cw.session_name() : cw.family_name();
      });

      return ko.utils.arrayGetDistinctValues(list);
    });
  };

  self.initCourseworkNav = function () {
    self.getCoursework(self.coursework_id()).done(function(response) {
      var mapped_coursework = ko.mapping.fromJS(response.coursework);
      self.coursework(mapped_coursework);

      self.refreshURL();
    });
  };

  self.getCoursework = _.memoize(function (coursework_id) {
    return new Kadenze.AjaxRequest({
      type: 'GET',
      url: Kadenze.Routes.course_gradebook_coursework_show_path(self.course_id, coursework_id)
    });
  });

  self.initSpreadsheet = function() {
    var tab = self.activeTab();
    if (_.includes(['grades', 'analytics'], tab)) {
      if (self[tab] == null) {
        var vmName = s.capitalize(tab) + 'VM';
        var vm = self.tabVMs[vmName];
        self[tab] = new vm(self.coursework_id());
        ko.applyBindingsWithValidation(self[tab], self[tab].$el[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
      } else if (self[tab].coursework_id() != self.coursework_id()) {
        self[tab].coursework_id(self.coursework_id());
      }
      self.refreshURL();
    }
  };

  self.showTab = function (tab) {
    self.activeTab(tab);
    var tabId = '#{name}-tab'.supplant({name: tab});
    var $el = $(tabId);
    $el.tab('show');
  };

  self.activeVM = function () {
    return self[self.activeTab()];
  };

  self.exportTable = function (item, event) {
    var vm = self.activeVM();
    vm && vm.exportTable();
    event.stopPropagation();
  };

  self.downloadAllSubmissions = function (item, event) {
    GradebookServices.downloadAllSubmissions(self.coursework());
  };

  self.rerunAllAutoGrading = function (item, event) {
    GradebookServices.presentAutoGradingOption(self.coursework().has_overridden_grade_entries(), function () {
      GradebookServices.rerunAllAutoGrading(self.course_id, self.coursework_id(), false);
    }, function () {
      GradebookServices.rerunAllAutoGrading(self.course_id, self.coursework_id(), true);
    });
  };

  const __construct = function(that) {
    console.log('constructor called for InstructorGradebook.Coursework.OverviewVM');
    that.course_id = $('#course_id').val();

    that.initCourseworkListing();

    //Update coursework nav and spreadsheet if student changes
    that.coursework_id($('#coursework_id').val());
    that.coursework_id.subscribe(that.initCourseworkNav);
    that.coursework_id.subscribe(that.initSpreadsheet);

    that.initCourseworkNav();

    //Update spreadsheet if active sheet changes
    var sheet = Kadenze.Util.getParameterByName('sheet');
    that.activeTab.subscribe(that.initSpreadsheet);
    that.showTab(sheet || 'grades');
  }(this);
}

